import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import { hash } from "rsvp"

export default class CourseRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    return hash({
      course: get(this, "store").find("course", params.course_id),
      courseCalendar: get(this, "store").find("course-calendar", params.course_id),
    })
  }
}
